module.exports = __webpack_public_path__ + "static/img/header-img.0293464a.png";